import { createApp } from 'vue';
import store from './store';
import 'es6-promise/auto';

/**
 * Components
 */
import Welcome from './components/Welcome.vue';
import EventCalendar from './components/Events/EventCalendar';
import EventCard from './components/Events/EventCard';
import EventsList from './components/Events/EventsList';
import PostGallery from './components/PostGallery';
import ForceMajeurs from './components/ForceMajeurs.vue';

createApp({
  components: {
    Welcome,
    EventCalendar,
    EventCard,
    EventsList,
    PostGallery,
    ForceMajeurs,
  },
})
  .use(store)
  .mount('#app');
